function Index(props) {

    return (
      <div className="divecard">  
            <div className="intro">
                <p>There is adventure in every dive why not save your favorite<br></br> experiences here in a digital divelog! </p>
                <img src="https://i.imgur.com/5FMBjeq.jpg" alt=""/>
            </div>        
      </div>
   
    )
  }
  
  export default Index